import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ConstellationControls = ({ 
  onZoomIn, 
  onZoomOut, 
  onReset, 
  onToggleRotation,
  isRotating,
  currentFilter,
  onFilterChange,
  zoomLevel = 1
}) => {
  const filters = [
    { id: 'all', name: 'All Skills', icon: 'Globe' },
    { id: 'technical', name: 'Technical', icon: 'Code' },
    { id: 'creative', name: 'Creative', icon: 'Palette' },
    { id: 'hybrid', name: 'Hybrid', icon: 'Zap' }
  ];

  return (
    <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-30">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1 }}
        className="glass-panel rounded-full px-6 py-3 shadow-cosmic-lg"
      >
        <div className="flex items-center space-x-4">
          {/* Filter Buttons */}
          <div className="flex items-center space-x-2">
            {filters?.map((filter) => (
              <Button
                key={filter?.id}
                variant={currentFilter === filter?.id ? "default" : "ghost"}
                size="sm"
                onClick={() => onFilterChange(filter?.id)}
                className={`${
                  currentFilter === filter?.id 
                    ? 'bg-accent text-background' :'text-muted-foreground hover:text-foreground'
                }`}
                iconName={filter?.icon}
                iconSize={16}
              >
                <span className="hidden sm:inline">{filter?.name}</span>
              </Button>
            ))}
          </div>

          {/* Divider */}
          <div className="w-px h-6 bg-border/30" />

          {/* Zoom Controls */}
          <div className="flex items-center space-x-1">
            <Button
              variant="ghost"
              size="sm"
              onClick={onZoomOut}
              disabled={zoomLevel <= 0.5}
              className="text-muted-foreground hover:text-foreground disabled:opacity-50"
            >
              <Icon name="ZoomOut" size={16} />
            </Button>
            
            <div className="px-2 py-1 bg-surface/30 rounded text-xs font-body text-muted-foreground min-w-[3rem] text-center">
              {Math.round(zoomLevel * 100)}%
            </div>
            
            <Button
              variant="ghost"
              size="sm"
              onClick={onZoomIn}
              disabled={zoomLevel >= 2}
              className="text-muted-foreground hover:text-foreground disabled:opacity-50"
            >
              <Icon name="ZoomIn" size={16} />
            </Button>
          </div>

          {/* Divider */}
          <div className="w-px h-6 bg-border/30" />

          {/* Rotation Toggle */}
          <Button
            variant="ghost"
            size="sm"
            onClick={onToggleRotation}
            className={`${
              isRotating 
                ? 'text-accent' :'text-muted-foreground hover:text-foreground'
            }`}
          >
            <Icon 
              name="RotateCw" 
              size={16} 
              className={isRotating ? 'animate-spin' : ''} 
            />
          </Button>

          {/* Reset Button */}
          <Button
            variant="ghost"
            size="sm"
            onClick={onReset}
            className="text-muted-foreground hover:text-foreground"
          >
            <Icon name="RotateCcw" size={16} />
          </Button>
        </div>
      </motion.div>
      {/* Help Text */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 2 }}
        className="text-center mt-3"
      >
        <p className="font-body text-xs text-muted-foreground">
          Click on stars to explore skills • Drag to rotate • Scroll to zoom
        </p>
      </motion.div>
    </div>
  );
};

export default ConstellationControls;